import { Container, Graphics, Sprite, Texture } from 'pixi.js'

// 符號視圖 — 顯示任意貼圖（符號或倍數幣），置中等比縮放至格內；中獎/啟用時加亮框。
export class SymbolView extends Container {
  private readonly frame = new Graphics()
  private readonly sprite = new Sprite()

  private cellW = 0
  private cellH = 0
  private highlighted = false

  constructor() {
    super()
    this.sprite.anchor.set(0.5)
    this.addChild(this.frame, this.sprite)
  }

  /** 設定格子寬高（可非正方；符號等比置中於格內）。 */
  setCell(width: number, height: number): void {
    this.cellW = width
    this.cellH = height
    this.fitSprite()
    this.redrawFrame()
  }

  setTexture(texture: Texture | null): void {
    this.sprite.texture = texture ?? Texture.EMPTY
    this.fitSprite()
  }

  setHighlight(on: boolean): void {
    if (this.highlighted === on) return
    this.highlighted = on
    this.redrawFrame()
    this.fitSprite()
  }

  setDimmed(dim: boolean): void {
    this.alpha = dim ? 0.4 : 1
  }

  private fitSprite(): void {
    const w = this.cellW
    const h = this.cellH
    if (w <= 0 || h <= 0) return
    this.sprite.position.set(w / 2, h / 2)
    const texture = this.sprite.texture
    if (texture === Texture.EMPTY || texture.width === 0 || texture.height === 0) return
    const inner = Math.min(w, h) * (this.highlighted ? 1.04 : 0.98)
    const scale = Math.min(inner / texture.width, inner / texture.height)
    this.sprite.scale.set(scale)
  }

  private redrawFrame(): void {
    const w = this.cellW
    const h = this.cellH
    if (w <= 0 || h <= 0) return
    const g = this.frame
    g.clear()
    if (this.highlighted) {
      const pad = Math.min(w, h) * 0.04
      g.roundRect(pad, pad, w - pad * 2, h - pad * 2, Math.min(w, h) * 0.14)
      g.fill({ color: 0xffe680, alpha: 0.16 })
      g.stroke({ width: Math.max(2, Math.min(w, h) * 0.05), color: 0xffe680 })
    }
  }
}
